var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g(_vm._b({staticClass:"ebp-button",class:_vm.className,attrs:{"disabled":_vm.loading}},'b-button',_vm.attrs,false),_vm.$listeners),[(_vm.loading)?_c('i',{staticClass:"bx bx-loader bx-spin font-size-16 align-middle mr-2"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }